import { fetchOrLogout } from "../../../utils/helpers";
import { getBaseUrl } from "../../../utils/requestUtils";

export interface LoginRequestType {
  email: string;
  password: string;
}

export const LoginInitialValues: LoginRequestType = {
  email: "",
  password: "",
};

export const LoginRequest = async (
  loginInfo: LoginRequestType,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetch(`${baseUrl}/api/v1/provider_portal/login`, {
    body: JSON.stringify(loginInfo),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const GetNewProviderInfoFromToken = async (
  token: string,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/login/token`,
    {
      method: "POST",
      body: JSON.stringify({ token }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};

export default LoginRequest;
